
const PledgeFooter = () => {
  return (
    <div className="text-center">
      <p className="text-sm text-muted-foreground mt-6 bg-blue-50 border border-blue-200 rounded-lg p-3 max-w-2xl mx-auto">
        💡 <strong>Simple process:</strong> Provide your information, complete payment, and we'll handle the rest. You'll receive email updates and can create your account when we launch in December 2025!
      </p>
      
      <p className="text-xs text-muted-foreground mt-4">
        Promotional pricing active until December 2025 launch. Your subscription begins immediately with early access features.
      </p>
    </div>
  );
};

export default PledgeFooter;
